import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import LKButton from 'shared/LKButton'
import { ComponentContainer } from './StyledComponents'

const LKDropdownButton = ({
  className,
  containerStyle = {},
  style,
  name,
  loading,
  upward,
  closeMenu,
  leftward,
  options = [],
  buttonId,
  disabled,
  permission,
  alias,
  onOpen,
  change,
  value,
}) => (
  <ComponentContainer
    style={{ display: 'inline-block', width: 'auto', ...containerStyle }}
    dropdown
    floatLeft={leftward}
  >
    <Dropdown
      trigger={
        <LKButton
          // name={'lkPrint' + this.printName}
          className={className}
          style={style}
          id={buttonId}
          loading={loading}
          disabled={loading || disabled}
          alias={alias}
          permission={permission}
        >
          {name}
        </LKButton>
      }
      // open={isOpen}
      style={containerStyle}
      openOnFocus={false}
      onOpen={onOpen}
      onClose={closeMenu}
      loading={loading}
      disabled={loading || disabled}
      upward={upward}
      icon={null}
      onChange={change}
      options={options}
      selectOnBlur={false}
      leftward={leftward}
      value={value}
    />
  </ComponentContainer>
)

export default LKDropdownButton
